import React from 'react'
import Autosuggest from '@cloudscape-design/components-themed/autosuggest'

// https://cloudscape.design/components/autosuggest
export function RadAutosuggest ({ ...rest }) {
  return (
    <Autosuggest {...rest} />
  )
}
